import React from "react";

import { enums } from "../../enums/"

import { assets } from "../../assets/";
import { getColorsWithAlpha } from "../../constants/Colors";
//import { BarChartCardContent } from "./BarChartCardContent";

const backgroundColors = getColorsWithAlpha(0.9);
const borderColors = getColorsWithAlpha(1);

export class BarChartLegend extends React.Component {
  
  render() {
    const {
      classes,
      loading,
      barChartData
    } = this.props;

    //if (loading || !barChartData) { return false }
    if (loading) { return false }

    return (
      <ul
        style={{
          listStyleType: "none",
          width: "100%",
          margin: 0,
          padding: 0
        }}
      >
        {barChartData.data.map((item, index) => {
          let assetIcon;
    
          switch (item.assetType) {
            case enums.AssetType.WIND_TURBINE:
              assetIcon = assets.images.windTurbineMapIcon2;
              break;
            case enums.AssetType.SOLAR_PANEL:
              assetIcon = assets.images.solarPanelMapIcon2;
              break;
            case enums.AssetType.DAM:
              assetIcon = assets.images.damMapIcon2;
              break;
            case enums.AssetType.FACTORY:
              assetIcon = assets.images.factoryMapIcon2;
              break;
            case enums.AssetType.GEOTHERMAL:
              assetIcon = assets.images.geothermalIcon;
              break;
            case enums.AssetType.SOLID_BIOMASS:
              assetIcon = assets.images.solidBiomassIcon;
              break;
            default:
              assetIcon = assets.images.boltMapIcon2;
          }
    
          return (
            <li
              key={`bar-chart-legend-${index}`}
              className={classes.legend}
              onClick={() => {
                if (this.props.barChart.chart) {
                  let ci = this.props.barChart.chart.chartInstance;
                  ci.data.datasets.forEach(function (e, j) {
                    let meta = ci.getDatasetMeta(j);
                    if (j === index) {
                      meta.hidden = meta.hidden === null ? !meta.hidden : null;
                    }
                  });
                  ci.update();
                }
              }}
            >
              <div
                style={{
                  backgroundColor: backgroundColors[index],
                  borderWidth: 1,
                  borderColor: borderColors[index],
                  width: 42,
                  height: 14,
                  float: "left",
                  margin: "2px 5px 2px 0px"
                }}
              />
              <img
                src={assetIcon}
                alt="asset_icon"
                style={{
                  maxHeight: 16,
                  marginLeft: 5,
                  marginRight: 5
                }}
              />
              <span>{item.label}</span>
            </li>
          );
        })}
      </ul>
  )}
}


// WEBPACK FOOTER //
// ./src/components/ChartCards/BarChartLegend.js